<template>
    <div class="location-back">
        <!--环图片-->
        <div class="img-box">
            <div class="prop-up"></div>
            <img src="@/assets/img/circle.png" class="circle" alt="">
        </div>
        <!--题目-->
        <div class="subject">
            <div>{{$t('enterTitle4')}}</div>
        </div>
        <!--选项-->
        <div style="width:220px;margin:calc(0.035 * var(--body-height)) auto 0;">
            <el-checkbox-group v-model="checkedTrans" :max="3">
                <el-checkbox :label="$t('trans1')"></el-checkbox>
                <br>
                <el-checkbox :label="$t('trans2')"></el-checkbox>
                <br>
                <el-checkbox :label="$t('trans3')"></el-checkbox>
                <el-checkbox :label="$t('trans4')"></el-checkbox>
                <el-checkbox :label="$t('trans5')"></el-checkbox>
                <el-checkbox :label="$t('trans6')"></el-checkbox>
                <div style="display:flex;align-items: baseline">
                    <el-checkbox :label="$t('trans7')"></el-checkbox>
                    <el-input v-model="otherTrans"
                              :disabled="inputDisabled"
                              maxlength="10"
                              :placeholder="this.$t('outLocate9Specify')"
                              style="width:calc(0.40 * var(--body-width));">
                    </el-input>
                </div>
            </el-checkbox-group>
        </div>
        <!--题目跳转-->
        <div class="subject-jump">
            <span @click="prevClick" class="prev-btn">{{$t('preQues')}}</span>
            <el-button @click="nextClick"
                       :disabled="countNumber!=0"
                       style="width:160px;"
                       type="primary">{{$t('nextQues')}} <i class="icon-right"></i> ({{countNumber}}s)
            </el-button>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "garden_enter4",
        data() {
            return {
                //次数
                checkedTrans: [],
                otherTrans: '',
                timer: null,
                countNumber: 0
            }
        },
        computed: {
            ...mapGetters([
                'enter4Answer'
            ]),
            inputDisabled() {
                return this.checkedTrans.length === 3 && !this.checkedTrans.includes(this.$t('intent9'))
            }
        },
        watch: {
            '$route': {
                immediate: true, // 组件创建时立即触发
                handler(newVal, oldVal) {
                    this.$store.commit('SET_ANSWER_PERCENT', 12 * 100 / 22)
                }
            }
        },
        mounted() {
            this.countdown()
            this.init()
        },
        methods: {

            /**
             * 初始化
             */
            init() {
                let copyArr = JSON.parse(JSON.stringify(this.enter4Answer))
                let len = copyArr.length;
                if (len > 1) {
                    let char = copyArr.splice(len - 1, 1)
                    if (char[0] === '无') {
                        this.otherTrans = ''
                    } else {
                        this.otherTrans = char[0]
                    }
                }
                this.checkedTrans = copyArr
            },

            /**
             * 上一题
             */
            prevClick() {
                this.$router.push('/enter3')
            },

            /**
             * 下一题
             */
            nextClick() {
                if (this.checkedTrans.length < 1) {
                    this.$toast(this.$t('selectOne'));
                    return;
                }

                //选择其他时
                if (this.checkedTrans.includes(this.$t('trans7'))) {
                    if (this.otherTrans == '' || this.otherTrans == '无') {
                        this.$toast(this.$t('chooseOtherTip'));
                        return;
                    } else {
                        let reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/
                        if (!reg.test(this.otherTrans)) {
                            this.$toast(this.$t('wordReg'));
                            return;
                        }
                    }
                } else {
                    this.otherTrans = ''
                }

                //保存答案
                let arr = this.checkedTrans
                if (this.checkedTrans.includes(this.$t('intent9'))) {
                    arr.push(this.otherTrans)
                } else {
                    arr.push('无')
                }
                this.$store.commit('SET_ENTER4_ANSWER', arr)
                this.$router.push('/enter5')
            },

            /**
             * 验证码倒计时
             */
            countdown() {
                let that = this;
                this.countNumber = 2;
                if (this.timer) {
                    clearInterval(this.timer);
                }
                this.timer = setInterval(function () {
                    if (that.countNumber === 0) {
                        clearInterval(this.timer);
                    } else {
                        that.countNumber--;
                    }
                }, 1000);
            }
        }
    }
</script>

<style scoped lang="less">
    .location-back {
        height: 100%;
    }

</style>